<div class="border-container">
    <div class="d-flex justify-content-center" *ngIf="isLoading">
        <div class="spinner-wrapper">
            <div class="tryb-design-spinner"></div>
        </div>
    </div>

    <ng-container *ngIf="!isLoading">
        <div class="table-responsive-wrapper">
            <table class="table" id="organization-member-list">
                <caption hidden>
                    Organization member list
                </caption>
                <thead>
                    <tr>
                        <th scope="col">
                            {{
                                'organization.organizationArea.members.columns.email'
                                    | translate
                            }}
                        </th>
                        <th scope="col">
                            {{
                                'organization.organizationArea.members.columns.displayName'
                                    | translate
                            }}
                        </th>
                        <th scope="col">
                            {{
                                'organization.organizationArea.members.columns.role'
                                    | translate
                            }}
                        </th>
                        <th scope="col">
                            {{
                                'organization.organizationArea.members.columns.status'
                                    | translate
                            }}
                        </th>
                        <th
                            scope="col"
                            [title]="
                                'organization.organizationArea.members.columns.membershipTypeTooltip'
                                    | translate
                            "
                        >
                            {{
                                'organization.organizationArea.members.columns.membershipType'
                                    | translate
                            }}
                            <img
                                class="icon"
                                src="assets/svg/algorithm/info-hover.svg"
                                alt="info circle"
                            />
                        </th>
                        <th
                            scope="col"
                            class="action-column"
                            aria-label="Actions"
                        ></th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let entry of memberListEntries; let i = index">
                        <td class="text-break">{{ entry.email }}</td>
                        <td class="text-break">
                            {{ entry.displayName || '-' }}
                        </td>
                        <td>
                            <div
                                *ngIf="
                                    canManageRoles && entry.type === 'member';
                                    else displayRole
                                "
                                class="tryb-dropdown role-dropdown"
                            >
                                <select
                                    [disabled]="
                                        isRoleChangeInProgress(entry.id)
                                    "
                                    [attr.aria-label]="
                                        'organization.organizationArea.members.columns.role'
                                            | translate
                                    "
                                    (change)="
                                        onRoleChange(
                                            entry,
                                            $any($event.target).value
                                        )
                                    "
                                >
                                    <option
                                        *ngFor="
                                            let role of organizationMemberRoles
                                        "
                                        [value]="role"
                                        [selected]="entry.role === role"
                                    >
                                        {{
                                            getRoleTranslationKey(role)
                                                | translate
                                        }}
                                    </option>
                                </select>
                            </div>
                            <ng-template #displayRole>
                                {{
                                    getRoleTranslationKey(entry.role)
                                        | translate
                                }}
                            </ng-template>
                        </td>
                        <td>
                            {{
                                getStatusTranslationKey(entry.status)
                                    | translate
                            }}
                        </td>
                        <td>
                            {{
                                (entry.membershipType === 'MANAGED'
                                    ? 'organization.organizationArea.members.membershipType.orgbound'
                                    : entry.membershipType === 'UNMANAGED'
                                      ? 'organization.organizationArea.members.membershipType.unbound'
                                      : '-'
                                ) | translate
                            }}
                        </td>
                        <td class="action-column">
                            <div
                                *ngIf="invitationActionsMenuIndex !== i"
                                class="action-buttons"
                            >
                                <button
                                    *ngIf="entry.type === 'invitation'"
                                    type="button"
                                    class="invitation-actions-button"
                                    (click)="onOpenInvitationActionsMenu(i)"
                                    [attr.aria-label]="
                                        'organization.organizationArea.members.columns.actions'
                                            | translate
                                    "
                                >
                                    <img
                                        src="assets/svg/reusable-svg/icon-dots.svg"
                                        alt="invitation actions"
                                    />
                                </button>
                            </div>
                            <div
                                *ngIf="invitationActionsMenuIndex === i"
                                class="action-buttons"
                            >
                                <button
                                    (click)="onResendInvitation(entry.id)"
                                    [title]="
                                        'organization.organizationArea.members.actions.resend'
                                            | translate
                                    "
                                >
                                    <img
                                        src="assets/svg/reusable-svg/email.svg"
                                        alt="resend invitation action"
                                    />
                                </button>
                                <button
                                    (click)="onCancelInvitation(entry.id)"
                                    [title]="
                                        'organization.organizationArea.members.actions.cancel'
                                            | translate
                                    "
                                >
                                    <img
                                        src="assets/svg/project-split-screen/tree/icon-trash.svg"
                                        alt="cancel invitation action"
                                    />
                                </button>
                                <button
                                    (click)="onOpenInvitationActionsMenu(-1)"
                                    [title]="
                                        'organization.organizationArea.members.actions.close'
                                            | translate
                                    "
                                >
                                    <img
                                        src="assets/svg/reusable-svg/close.svg"
                                        alt="close invitation actions menu"
                                    />
                                </button>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <span class="seats" *ngIf="seats">{{ getSeatsText() }}</span>
        </div>

        <div class="actions-bar">
            <div *ngIf="canManageInvitations" class="invite-button placeholder">
                {{ 'organization.organizationArea.members.invite' | translate }}
            </div>
            <app-simple-tryb-pagination
                [collectionSize]="collectionSize"
                [page]="page"
                [pageSize]="pageSize"
                [maxSize]="maxSize"
                (pageChange)="onPageChange($event)"
            ></app-simple-tryb-pagination>
            <button
                *ngIf="canManageInvitations"
                type="button"
                class="invite-button"
                [ngClass]="{
                    disabled: collectionSize >= seats,
                }"
                (click)="openInviteDialog()"
                [disabled]="collectionSize >= seats"
                [title]="
                    (collectionSize >= seats
                        ? 'organization.organizationArea.members.seatLimitReachedMessage'
                        : ''
                    ) | translate
                "
            >
                {{ 'organization.organizationArea.members.invite' | translate }}
            </button>
        </div>
    </ng-container>
</div>
